import {useEffect, useState} from 'react';

import {registerDefaultHeader} from 'fetcher/useFetcher';
import {useInterval} from 'hooks';
import {isDemo} from 'lib/env';
import {useLoadActiveLockerrooms,} from 'module/lockerRoom/useLoadActiveLockerrooms';
import {useLoadActiveUsersInLockerroom} from 'module/lockerRoom/useLoadActiveUsersInLockerroom';
import {useLockerRoomStore} from 'module/lockerRoom/zustand';
import {usePairingLoad, usePairingStore} from 'module/pairing';
import {useUserStore} from 'module/user';
import {useUserUtils} from 'module/user/useUser';
import {useApiGet} from 'module/user/useUserApi';

import demoCampaign from './assets/demodata/campaign.json';
import demoInfo from './assets/demodata/info.json';
import {loadCampaign} from './store/campaign';
import {loadInfo} from './store/info';
import {useCampaignStore, useInfoStore} from './store';

const Periodic = () => {
    const [timer, setTimer] = useState(0);
    const setInfo = useInfoStore(state => state.setInfo);
    const setCampaign = useCampaignStore(state => state.setCampaign);
    const isLockerroomActive = useLockerRoomStore((state) => state.active);
    const activePairing = usePairingStore((state) => state.activePairing);
    const setActivePairing = usePairingStore((state) => state.set);
    const unsetActivePairing = usePairingStore((state) => state.unset);
    const {pairing} = usePairingLoad();
    const {logout} = useUserUtils();

    const setUser = useUserStore(state => state.setUser);
    const user = useUserStore(state => state.user);
    const query = useApiGet();

    const loadActiveLockerrooms = useLoadActiveLockerrooms();
    const loadActiveUsersInLockerroom = useLoadActiveUsersInLockerroom();

    const load = async () => {
        // setIsLoadingLockerrooms(true);
        const info = await loadInfo();
        setInfo(isDemo() ? demoInfo : info);

        const campaign = await loadCampaign();
        setCampaign(isDemo() ? demoCampaign : campaign);

        if (!isLockerroomActive) {
            await loadActiveLockerrooms();
        } else {
            await loadActiveUsersInLockerroom();
        }
    };

    const loadPairing = async () => {
        // Don't do anything if there's no active pairing ID
        if (!activePairing?.id) {
            console.log('[Periodic] No active pairing ID, skipping loadPairing');
            return;
        }

        console.log('[Periodic] Loading pairing, activePairing:', activePairing);

        // 1. refresh pairing data to get user token
        // 2. refresh token every 4 minutes
        if ((activePairing?.id && !activePairing?.jwt) || (activePairing?.id && timer > 240)) {
            setTimer(0);
            try {
                let newPairing = await pairing(activePairing.id);

                if (newPairing.jwt && newPairing.jwt !== activePairing.jwt) {
                    setActivePairing({...activePairing, jwt: newPairing.jwt, valid_until: newPairing.valid_until});
                    registerDefaultHeader('Authorization', `Bearer ${newPairing.jwt}`);

                    if (!user || !user.id) {
                        // First pairing: fetch user data
                        let newUser = await query.refetch();
                        setUser({jwt: newPairing.jwt, ...newUser.data});
                    } else {
                        // Token refresh: update JWT only
                        setUser({...user, jwt: newPairing.jwt});
                    }
                }

            } catch (error) {
                // no active pairing
            }

        } else {
            if (activePairing.jwt) {
                // check pairing every 5 seconds
                if (timer % 5 === 0) {
                    try {
                        await pairing(activePairing.id);
                    } catch (error) {
                        // pairing inactive: logout
                        unsetActivePairing();
                        logout();
                    }
                }

            }

            setTimer(timer + 1);

        }

    };

    useEffect(() => {
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useInterval(async () => {
        load();
    }, 5 * 1000);

    useInterval(async () => {
        loadPairing();
    }, activePairing?.id ? 1000 : null);

    // Debug: Log activePairing changes
    useEffect(() => {
        console.log('[Periodic] activePairing changed:', activePairing);
    }, [activePairing]);

    return null;
};

export default Periodic;